module.exports = __webpack_public_path__ + "static/media/OOFF23.8c84868e.jpg";